module.exports = __webpack_public_path__ + "static/slide3.6e2ffbb6.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slide3.jpeg
// module id = 1705
// module chunks = 173894859265406